
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"totals_sit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CatScope"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TypeScope"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryTotalsSitWhereWhereConditions"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_debut"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_fin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totals_sit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CatScope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CatScope"}}},{"kind":"Argument","name":{"kind":"Name","value":"TypeScope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TypeScope"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_debut"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_debut"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_fin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_fin"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paye_enl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paye_fact"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"situation_gl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cmd_ttc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tot_paye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"val_tot_liv"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"val_tot_ret"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"situation_enl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"situation_fact"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ttc_fact"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ttc_fact_av"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ttc_enl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tot_fact"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tot_mvm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"situation_ini"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"situation_bl_ini"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"situation_ini_tot"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":589}};
    doc.loc.source = {"body":"query totals_sit(\r\n  $CatScope: [ID]\r\n  $TypeScope: Int\r\n  $where: QueryTotalsSitWhereWhereConditions\r\n  $date_debut: String\r\n  $date_fin: String\r\n) {\r\n  totals_sit(\r\n    CatScope: $CatScope\r\n    TypeScope: $TypeScope\r\n    where: $where\r\n    date_debut: $date_debut\r\n    date_fin: $date_fin\r\n  ) {\r\n    paye_enl\r\n    paye_fact\r\n    situation_gl\r\n    cmd_ttc\r\n    tot_paye\r\n    val_tot_liv\r\n    val_tot_ret\r\n    situation_enl\r\n    situation_fact\r\n    ttc_fact\r\n    ttc_fact_av\r\n    ttc_enl\r\n    tot_fact\r\n    tot_mvm\r\n    situation_ini\r\n    situation_bl_ini\r\n    situation_ini_tot\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["totals_sit"] = oneQuery(doc, "totals_sit");
        
